import React from 'react'

const Projects = () => {
    return (
        <>
            <div className="container-fluid">
                <h1 className="text-center my-3">
                    Projects? We got it 😁
             </h1>
            </div>
        </>
    )
}

export default Projects
